import { Link } from "react-router-dom";
import { CheckCircle, LogIn } from "lucide-react";
import { motion } from "framer-motion";

export default function ResetSuccess() {
  return (
    <div className="h-[80vh] flex items-center justify-center bg-gray-100">
      {/* Animate the card */}
      <motion.div
        initial={{ opacity: 0, y: 30, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="w-full max-w-md bg-white rounded-lg shadow-lg p-8 text-center"
      >
        {/* Success Icon with Bounce Animation */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{
            type: "spring",
            stiffness: 300,
            damping: 15,
            delay: 0.2,
          }}
          className="flex justify-center mb-4"
        >
          <CheckCircle className="text-green-500" size={65} />
        </motion.div>

        {/* Heading */}
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          Password Reset Successful!
        </h1>

        {/* Subtitle */}
        <p className="text-gray-600 mb-6">
          Your password has been updated successfully. You can now log in with
          your new password.
        </p>

        {/* Go to Login Button */}
        <motion.div whileTap={{ scale: 0.96 }} whileHover={{ scale: 1.02 }}>
          <Link
            to="/signin"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-md flex items-center justify-center gap-2 transition duration-200"
          >
            <LogIn className="w-4 h-4" /> Go to Sign In
          </Link>
        </motion.div>
      </motion.div>
    </div>
  );
}
